/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "./home.scss";
import {
  Card,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Dropzone from "react-dropzone";
import { Constants } from "../../Constants";
import { imageUpload } from "../../services/BannersServices";
import { fetchHome, putHome } from "../../services/HomeServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import ViewInWeb from "../../components/Common/ViewInWeb";
import { EditorState } from "draft-js";
import { stateFromHTML } from "draft-js-import-html";
import { stateToHTML } from "draft-js-export-html";
import { Editor } from "react-draft-wysiwyg";

const Item = ({
  image,
  description,
  setDescription,
  title,
  setTitle,
  handleAcceptedFiles,
  position,
}: any) => (
  <div className="col-12 col-md-4 item">
    <input value={title} onChange={(e) => setTitle(e.target.value)} />
    <Editor
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      toolbar={{
        options: ["inline", "blockType", "link", "emoji", "image"],
        inline: { inDropdown: true },
        link: { inDropdown: true },
      }}
      editorState={description}
      onEditorStateChange={(d: any) => setDescription(d)}
    />
    <Dropzone
      onDrop={(acceptedFiles) => {
        handleAcceptedFiles(acceptedFiles, position);
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div className="dropzone" style={{ marginTop: "1rem" }}>
          <div className="dz-message needsclick mt-2" {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="mb-3">
              <i className="display-4 text-muted bx bxs-cloud-upload" />
            </div>
            <h4>Drop files here or click to upload.</h4>
          </div>
        </div>
      )}
    </Dropzone>
    <div className="dropzone-previews mt-3" id="file-previews">
      {image && (
        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
          <div className="p-2">
            <Row className="align-items-center">
              <Col className="col-auto">
                <img
                  data-dz-thumbnail=""
                  height="80"
                  className="avatar-sm rounded bg-light"
                  alt=""
                  src={`${Constants.BASE_URL}${image}`}
                />
              </Col>
            </Row>
          </div>
        </Card>
      )}
    </div>
  </div>
);

function Home() {
  const [firstTitle, setFirstTitle] = useState("");
  const [firstDescription, setFirstDescription] = useState(
    EditorState.createEmpty()
  );
  const [firstImage, setFirstImage] = useState("");
  const [secondTitle, setSecondTitle] = useState("");
  const [secondDescription, setSecondDescription] = useState(
    EditorState.createEmpty()
  );
  const [secondImage, setSecondImage] = useState("");
  const [thirdTitle, setThirdTitle] = useState("");
  const [thirdDescription, setThirdDescription] = useState(
    EditorState.createEmpty()
  );
  const [thirdImage, setThirdImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState("");

  useEffect(() => {
    fetch();
  }, []);

  const handleAcceptedFiles = async (files: any, key: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "home",
        });
        if (key === "first") {
          setFirstImage(response.data.data.image);
        }
        if (key === "second") {
          setSecondImage(response.data.data.image);
        }
        if (key === "third") {
          setThirdImage(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchHome({
        token: "",
      });
      let {
        title1,
        description1,
        logo1,
        title2,
        description2,
        logo2,
        title3,
        description3,
        logo3,
        footerImage,
      } = response.data.data.config;
      setLoading(false);
      setFirstTitle(title1);
      setFirstDescription(
        EditorState.createWithContent(stateFromHTML(description1))
      );
      setFirstImage(logo1);
      setSecondTitle(title2);
      setSecondDescription(
        EditorState.createWithContent(stateFromHTML(description2))
      );
      setSecondImage(logo2);
      setThirdTitle(title3);
      setThirdDescription(
        EditorState.createWithContent(stateFromHTML(description3))
      );
      setThirdImage(logo3);
      setImage(footerImage);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await putHome({
        token: "",
        title1: firstTitle,
        description1: stateToHTML(firstDescription.getCurrentContent()),
        logo1: firstImage,
        title2: secondTitle,
        description2: stateToHTML(secondDescription.getCurrentContent()),
        logo2: secondImage,
        title3: thirdTitle,
        description3: stateToHTML(thirdDescription.getCurrentContent()),
        logo3: thirdImage,
        footerImage: image,
      });
      setLoading(false);
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleFiles = async (event: any) => {
    for (let file of event.target.files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "banners",
        });
        setImage(response.data.data.image);
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="Home">
        <Container fluid={true}>
          <Breadcrumb title="Home" breadcrumbItem="Home" />
          <Row>
            <Col>
              {/*<Label>¿POR QUÉ ELEGIRNOS?</Label>
              <div className="row">
                <Item
                  image={firstImage}
                  description={firstDescription}
                  title={firstTitle}
                  setTitle={setFirstTitle}
                  setDescription={setFirstDescription}
                  handleAcceptedFiles={handleAcceptedFiles}
                  position="first"
                />
                <Item
                  image={secondImage}
                  description={secondDescription}
                  title={secondTitle}
                  setTitle={setSecondTitle}
                  setDescription={setSecondDescription}
                  handleAcceptedFiles={handleAcceptedFiles}
                  position="second"
                />
                <Item
                  image={thirdImage}
                  description={thirdDescription}
                  title={thirdTitle}
                  setTitle={setThirdTitle}
                  setDescription={setThirdDescription}
                  handleAcceptedFiles={handleAcceptedFiles}
                  position="third"
                />
              </div>*/}
              <FormGroup row>
                <Label
                  htmlFor="example-datetime-local-input"
                  className="col-md-2 col-form-label"
                >
                  Imagen
                </Label>
                <Col md={10}>
                  <div className="custom-file">
                    <CustomInput
                      id="file"
                      type="file"
                      name="file"
                      className="custom-file-input"
                      onChange={handleFiles}
                      style={{ marginTop: "0.5rem" }}
                    />
                  </div>
                </Col>
              </FormGroup>
              <img
                src={`${Constants.BASE_URL}${image}`}
                style={{ width: "100%" }}
              />

              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link="https://mariomendez.uy/" />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Home;
